import React, { Component , Fragment} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import 'moment/locale/ru';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import YearMonthPicker from '../Lib/YearMonthPicker';
//import { DatePicker } from "@material-ui/pickers";
//import DatePicker from 'react-datepicker';
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem'; 
import SelectDataList from '../Lib/SelectDataList';

import * as api from '../../api/apiFunc'
import * as R from 'ramda'

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
  button: {
    marginTop: theme.spacing.unit*3,
    marginLeft: theme.spacing.unit*8,
    color:'navy',
    fontWeight : "bold",
 },
 title: {
  marginTop: -theme.spacing.unit*2,
  marginBottom: theme.spacing.unit*3,
  textAlign: 'center',
  backgroundColor : '#f0f0f0'
},
message: {
  margin: theme.spacing.unit*2,
  textAlign: 'left',
},
grid: {
  flexGrow: 1,
  },
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '80vh',
    }
});


class ShowFilter extends Component {
 constructor(props) {
  super(props);

  this.maxLen = 0
  this.FiltVal = {}
  this.state = {
     open: this.props.open,
     lastvalue : null
   };
 }
/* componentDidMount() {
  const { columns, pick, deffilter } = this.props;
  console.log('deffilter===',deffilter);
  if (!api.isEmpty(deffilter)) {
    R.keys(deffilter).map(k => {
      const col = R.find(R.propEq('key', k))(columns)
      if (col._picklist && R.find(R.propEq('name', col._picklist))(pick)) {
        const curList = R.find(R.propEq('name', col._picklist))(pick).rows
        if (api.isNotEmptyArr(curList)) {
          const curLId = R.find(R.propEq('pk_id', deffilter[k]))(curList)
          const curId = curLId.id
          this.FiltVal[k] = curId
        }
      } else {
        this.FiltVal[k] = deffilter[k]
      }
    })
  }
 
 }*/ 
 
 handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  defaultSelectVal = (picklist_values,def_val) => {
    let def = picklist_values.map( x => {
      if (x.value == def_val) return (x) 
    })
    //console.log("def======",def);
    return def||{value :"",label:""}
  }


  render() {
    const { classes, columns, pick, deffilter } = this.props;
    //console.log('this.FiltVal---', this.FiltVal);
    if (!api.isEmpty(deffilter) && !api.isEmpty(this.FiltVal) && this.FiltVal["user_id"] ==0) {

      R.keys(deffilter).map(k => {
        const col = R.find(R.propEq('key', k))(columns)
        if (col._picklist && R.find(R.propEq('name', col._picklist))(pick)) {
          const curList = R.find(R.propEq('name', col._picklist))(pick).rows
          if (api.isNotEmptyArr(curList)) {
            const curLId = R.find(R.propEq('pk_id', deffilter[k]))(curList)
            const curId = curLId.id
            this.FiltVal[k] = curId
          }
        } else {
          if (k == 'period' && this.FiltVal[k] == undefined) 
            this.FiltVal[k] = new Date(deffilter[k]+"-01") 
          else
            this.FiltVal[k] = deffilter[k]
        }
      })
    }
  
   /* this.nbsp = new Object()
    this.mycol = new Object()
    this.maxLen = 0
    this.props.columns.map( (col) => this.maxLen = this.maxLen > col.name.length ? this.maxLen : col.name.length)
    this.props.columns.map( (col) => this.nbsp[col.name] = '..'.repeat(this.maxLen-col.name.length))
  */

   const InputMost = (col,type) => (
    <div className = {'row'} key={col.key} style={{display: 'flex', marginBottom: '10px', alignItems: 'center'}}>
      <label className = {'col-lg-3 component_label'}>
        {col.name} :
      </label>
      <div className = {'col-lg-9'}>
        <input 
          name = {col.key}
          //style={{border: '1px outset lightgray', padding: '3px' }}
          className="component_textfield"
          type={type}
          value={this.FiltVal[col.key]}
          onChange={(event,type) => { 
            this.FiltVal[col.key] = event.target.value  
            this.setState({ lastvalue: event.target.value });
          }}
        />
      </div>
    </div>
    )
    const InputCheck = (col) => {
     //console.log('this.FiltVal[col.key]',this.FiltVal[col.key]);
     //let chk = this.FiltVal[col.key] === 1 ?  : false
     return (
      <div className = {'row'} key={col.key} style={{display: 'flex', marginBottom: '10px', alignItems: 'center'}}>
        <label className = {'col-lg-3 component_label'}>
          {col.name} :
        </label>
        <div className = {'col-lg-9'}>
        <input 
          name = {col.key}
          
          style={{ border: '1px outset lightgray', padding: '3px' }}
          type='checkbox'
          checked={this.FiltVal[col.key] === 1 ? 'checked' : null }
          onChange={(event) => { 
            this.FiltVal[col.key] = event.target.checked ? 1 : 0 
            this.setState({ lastvalue: event.target.value });
          }}
        />
        </div>
      </div>
      )
    }
  
    const InputSelect = (col,rows ) => (
      <div className = {'row'} key={col.key} style={{display: 'flex', marginBottom: '10px', alignItems: 'center'}}>
        <label className = {'col-lg-3 component_label'}>
          {col.name} :
        </label>
        <div className={'col-lg-9'}>
              <SelectDataList
                    //styleClass = "matherial-slct field-limitter"
                    styleClass="customselect"
                    selectList={api.mutableListSelect(rows)}
                    curValue={this.defaultSelectVal(api.mutableListSelect(rows), this.FiltVal[col.key])}
                    onHandleChange={( _ , e) => { 
                      if (e.value)  
                       this.FiltVal[col.key] = e.value  
                       this.setState({ lastvalue: e.value });
                    }}
                    selName = {col.key} 
              />
          
          {/* <Select name={col.key} 
                      id={col.key} 
                      autoWidth={true}
                      className="Select component_select"
                      value={this.FiltVal[col.key]} 
                      onChange={(event) => { 
                        if (event.target.value)  
                          this.FiltVal[col.key] = event.target.value  
                        this.setState({ lastvalue: event.target.value });
                        event.preventDefault();
                      }}
                      >
                  {
                  rows.map(v => (<MenuItem value={v.id} key={v.id}>{v.title}</MenuItem>))
                  }
              </Select>
                */}
        </div>
      </div>
      )
   
      const InputMonthYear = (col) => {
        let dateValue =  new Date(this.FiltVal[col.key]+"-01")  
        if (dateValue === undefined) dateValue = new Date()     //'дд.мм.гггг'
        //let dateValue = moment(null)
        //let options = {year: 'numeric', month: 'numeric', day: 'numeric' };
    
         // <DatePicker selected={dateValue}
         return (
         <div className = {'row'} key={col.key} style={{display: 'flex', marginBottom: '10px', alignItems: 'center'}}>
            <label className = {'col-lg-3 component_label'}>
              {col.name} :
            </label>
             <div className={'col-lg-9'} style={{ alignItems: 'right' }}>
               <YearMonthPicker
                 selectedDate={dateValue}
                 handleDateChange={d => {
                  this.FiltVal[col.key] = d  
                  this.setState({ lastvalue: d })
                  }}
               />
            </div>
          </div>
       )}
    
   const InputDate = (col) => {
    let dateValue = this.FiltVal[col.key]
    if (dateValue === undefined)
      dateValue = 'дд.мм.гггг'
    //let dateValue = moment(null)
    //let options = {year: 'numeric', month: 'numeric', day: 'numeric' };

     // <DatePicker selected={dateValue}
     return (
     <div className = {'row'} key={col.key} style={{display: 'flex', marginBottom: '10px', alignItems: 'center'}}>
        <label className = {'col-lg-3 component_label'}>
          {col.name} :
        </label>
        <div className = {'col-lg-9'} style={{ alignItems: 'right' }}>
          <input 
              //style={{ border: '1px outset lightgray', padding: '3px' , float: 'center'}}
              className="component_textfield"
              value={dateValue}
              onChange={(event) => { 
                this.FiltVal[col.key] = event.target.value  
                this.setState({ lastvalue: event.target.value });
              }}
          />
        </div>
      </div>
   )}
    return (
      <div style={{height:'100%'}}>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="window-modal-filter"
          fullWidth={true}
          maxWidth="sm" 
        >
          <DialogTitle id="alert-dialog-title" className="component_app_title">{this.props.title}</DialogTitle>
          <DialogContent className="tttesttest testname">
          <div className='container'>
             {this.props.columns.map( (col) => {
              // if (R.not(col.filterable))  return null
               if (col._typecolumn ==='checkbox') {
                  return InputCheck(col) 
                }
                else 
                {
                  if (col._picklist&&R.find(R.propEq('name', col._picklist))(pick)){
                    let curpick = R.find(R.propEq('name', col._picklist))(pick) 
                    let pkRow = curpick.rows
                    let tmpRow = pkRow
                    // let Nbsp = "\u00A0".repeat(20) ie yt gjllth;bdftn
                    let Nbsp = "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"

                    if (R.not(R.find(R.propEq('id', 0))(pkRow)))
                      tmpRow = R.concat([{id:0,title:Nbsp}],pkRow); 
                      //pkRow.unshift({id:0,title:Nbsp});
                    //console.log('pkRow',pkRow); 
                    if (this.FiltVal[col.key] === undefined) 
                       this.FiltVal[col.key] = 0
                    //data.editor = <AutoCompleteEditor options={curpick.rows} />
                    //console.log('tmpRow----',tmpRow);
                    return InputSelect(col,tmpRow)
                  }
                  else
                  {
                    if (col._typedata === 5 || col._typedata === 6)
                        return InputDate(col) 
                    if (col._typedata === 15 )
                        return InputMonthYear(col) 
                    if (col._typedata === 1 || col._typedata === 2)                       
                        return InputMost(col,'number') 
                    return InputMost(col,'text') 
                  }
                }
              })
            }
          </div>
          </DialogContent>
          <DialogActions className="modal-buttonwrap">
           <Button className="component_button" onClick={() => {
              this.FiltVal = {}
              let callB = {}
              this.props.columns.map((col) => { 
                if (col.key == 'period') 
                  callB[col._alias ? col._alias : col.key] = moment(new Date()).format('YYYY-MM')
                else
                  callB[col._alias ? col._alias : col.key] = null
              })
              return (this.props.onAnswer(true,callB))}
            } color="primary" >
              Очистить фильтр
            </Button>
            <Button onClick={() => {
                  let callB = {}
                  this.props.columns.map( (col) => {
                    if (col._picklist&&R.find(R.propEq('name', col._picklist))(pick)){ 
                      console.log('this.FiltVal[col.key]',this.FiltVal[col.key]);
                      if (this.FiltVal[col.key] && this.FiltVal[col.key] !== 0) {
                        const idKey = this.FiltVal[col.key]
                        //const curPkId = R.find(R.propEq('name', col._picklist))(pick).rows[idKey-1].pkid
                        const curList = R.find(R.propEq('name', col._picklist))(pick).rows
                        const curPkId = R.find(R.propEq('id', idKey))(curList)
                        //console.log('callB-0-', callB);
                        if (curPkId)
                          callB[col._alias ? col._alias : col.key] = curPkId.pkid
                        }
                      else { 
                        callB[col._alias ? col._alias : col.key] = null
                      }

                    }
                    else
                    {
                      if (col.key == 'period' && this.FiltVal[col.key] == undefined) 
                        this.FiltVal[col.key] = new Date()
                      
                      if (this.FiltVal[col.key]) {
                        //console.log('callB-1-', callB);
                        let curval = this.FiltVal[col.key]
                        if (col._typedata == 5 || col._typedata == 6) {
                          if (typeof curval != 'string') {
                            curval = moment(curval).format('YYYY-MM-DD')
                          }
                          else {
                            //if (this.FiltVal[col.key].length>10){
                            curval = api.toDateFormatJSON(curval, ".")
                            //} 
                          }
                        }
                        else {
                          if (col._typedata == 15) {
                            if (typeof curval != 'string') {
                              curval = moment(curval).format('YYYY-MM')
                            }
                            else {
                              curval = api.toDateFormatJSON(curval, ".").substring(0, 6)
                            }
                          }
                        }
                        callB[col._alias ? col._alias : col.key] = curval
                      }
                      else {
                        callB[col._alias ? col._alias : col.key] = null
                       }
                    }
                  }) 
                  return this.props.onAnswer(true,callB)
                }
              } color="primary" className="component_button">
              Фильтровать
            </Button>
            <Button  onClick={() => this.props.onAnswer(false,this.FiltVal)} color="primary" className="component_button">
              Отмена
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ShowFilter.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ShowFilter);